import type { WidgetDefinition } from '../WidgetDefinition';
import { faNewspaper } from '@fortawesome/pro-regular-svg-icons/faNewspaper';
import type { NewsWidgetModel } from '@thinkalpha/ui-types/contracts/workspace';
import type { NewsWidgetViewModel } from 'src/store/types';

class NewsWidgetDefinition implements WidgetDefinition<NewsWidgetViewModel, NewsWidgetModel> {
    type = 'news' as const;
    nameKey = 'widgets::news::name' as const;
    roles = ['widgets::news'];
    icon = faNewspaper;
    category = 'widgets::categories::research' as const;
    defaultDimensions = { h: 0.8, w: 0.33, x: 0.33, y: 0.1 };

    /**
     * Converts a News widget from contract model to view model
     */
    toViewModel(widget: NewsWidgetModel): NewsWidgetViewModel {
        return widget;
    }

    /**
     * Converts a News widget from view model to contract model
     */
    toContractModel(widget: NewsWidgetViewModel): NewsWidgetModel {
        return widget;
    }
}

export const newsWidgetDefinition = new NewsWidgetDefinition();
